export default __webpack_public_path__ + "static/14-55ec20aea6723576a7510e5f6eef4114.webp";